import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Lightbulb, Send } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const field = 'w-full rounded-md border border-slate-300 px-3 py-2 text-sm';
const errText = (e) => { const d = e?.response?.data?.detail; return typeof d === 'string' ? d : 'Erro'; };

const TipsDialog = ({ job, onClose, onSent }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/admin/jobs/${job.id}/tips-compose`).then((r) => setF(r.data)).catch((e) => { toast.error(errText(e)); onClose(); }); }, [job.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try { await api.post(`/admin/jobs/${job.id}/send-tips`, { subject: f.subject, body: f.body }); toast.success(`Dicas enviadas para ${f.to}`); onSent(); onClose(); }
    catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto" data-testid="job-tips-dialog">
        <DialogHeader><DialogTitle>Ajudar a vaga «{job.title_pt}»</DialogTitle><DialogDescription>De: info@trabadju.cv · Para: {f?.to || '…'}{f?.last_sent_at ? ` · última vez a ${new Date(f.last_sent_at).toLocaleDateString('pt-PT')}` : ''}</DialogDescription></DialogHeader>
        {!f ? <p className="text-sm text-slate-500">A preparar…</p> : <div className="space-y-2">
          <input value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} maxLength={200} className={`${field} h-10`} data-testid="job-tips-subject" />
          <textarea value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} rows={14} maxLength={8000} className={field} data-testid="job-tips-body" />
          <p className="text-xs text-slate-500">Inclui no fim o botão «Editar a vaga».</p>
        </div>}
        <DialogFooter className="gap-2">
          <Button variant="outline" disabled={busy} onClick={onClose} data-testid="job-tips-cancel">Cancelar</Button>
          <Button onClick={send} disabled={busy || !f || f.body.trim().length < 20} data-testid="job-tips-send"><Send className="h-4 w-4 mr-1" />{busy ? 'A enviar…' : 'Enviar'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const JobTipsButton = ({ job, onSent }) => {
  const [open, setOpen] = useState(false);
  return <>
    <Button size="sm" variant="outline" className="h-7 border-amber-300 bg-white text-amber-800" onClick={() => setOpen(true)} data-testid={`admin-job-tips-${job.id}`}><Lightbulb className="h-3.5 w-3.5 mr-1" />Enviar dicas à empresa</Button>
    {job.tips_sent_at && <span className="text-[11px] text-emerald-700" data-testid={`admin-job-tips-sent-${job.id}`}>Dicas enviadas a {new Date(job.tips_sent_at).toLocaleDateString('pt-PT')}</span>}
    {open && <TipsDialog job={job} onClose={() => setOpen(false)} onSent={onSent} />}
  </>;
};
